import { EnvMicroAccounting } from "lib-klab-core";

export const envAccountingLocal: EnvMicroAccounting = {
  host: "",
  apiBasePath: "/ms-accounting",
  enabled: true,
  companyId: 2,
  useMocks: false,
};

export const envAccountingDev: EnvMicroAccounting = {
  host: "https://gatewayapi-dev.erp.inclub.world",
  apiBasePath: "/ms-accounting",
  enabled: true,
  companyId: 2,
  useMocks: false,
};

export const envAccountingProd: EnvMicroAccounting = {
  host: "",
  apiBasePath: "/ms-accounting",
  enabled: false,
  companyId: 2,
  useMocks: false,
};
